// extracted by mini-css-extract-plugin
export default {"parameter":"nKEFN","title":"u0pek lgaxY"};